// @ utilities
const { isChequeOrDebitAccount, isUpgradeableToPayrollAccount } = require('utilities/currentAccountsHelper.js');

//constants
const accountConstants = {
    ACCOUNTS: 'ACCOUNTS',
    ACCOUNTS_CANCEL_CHEQUE: 'ACCOUNTS_CANCEL_CHEQUE',
    ACCOUNTS_CANCEL_CHEQUEBOOK: 'ACCOUNTS_CANCEL_CHEQUEBOOK',
    ACCOUNTS_CHEQUEBOOK: 'ACCOUNTS_CHEQUEBOOK',
    ACCOUNTS_CHEQUES: 'ACCOUNTS_CHEQUES',
    ACCOUNTS_DEBIT_ANNULATION_PAYMENT: 'ACCOUNTS_DEBIT_ANNULATION_PAYMENT',
    ACCOUNTS_DEBIT_RETURN: 'ACCOUNTS_DEBIT_RETURN',
    ACCOUNTS_DEBITS: 'ACCOUNTS_DEBITS',
    ACCOUNTS_DEBITS_EDIT_VIEW: 'ACCOUNTS_DEBITS_EDIT_VIEW',
    ACCOUNTS_DETAILS: 'ACCOUNTS_DETAILS',
    ACCOUNTS_INTERVENER_REMOVE: 'ACCOUNTS_INTERVENER_REMOVE',
    ACCOUNTS_MOVEMENTS: 'ACCOUNTS_MOVEMENTS',
    ACCOUNTS_NEW_CHEQUEBOOK: 'ACCOUNTS_NEW_CHEQUEBOOK',
    ACCOUNTS_SETTLEMENTS: 'ACCOUNTS_SETTLEMENTS',
    ACCOUNTS_SETTLEMENTS_DETAILS: 'ACCOUNTS_SETTLEMENTS_DETAILS',
    ACCOUNT_PORTABILITY: 'ACCOUNT_PORTABILITY',
    ACCOUNT_UPGRADEABLE_TO_PAYROLL: 'ACCOUNT_UPGRADEABLE_TO_PAYROLL',
    ACCOUNT_AMAZON_GIFT_CARD: 'ACCOUNT_AMAZON_GIFT_CARD',
    ACCOUNT_UPLOAD_DOCUMENTATION: 'ACCOUNT_UPLOAD_DOCUMENTATION',
};
const { BASIC_PAYMENT_ACCOUNT_SUBTYPE,
        CURRENT_ACCOUNT_TYPE,
        EURO_TEXT,
        OPENYOUNG_ACCOUNT_TYPE,
        OPENYOUNG_ACCOUNT_SUBTYPE,
    } = require('constants/index');
const ACCOUNTS_REDIRECT_URL = '/myprofile/accounts';

const extractAccount = (immAccounts, accountId) => immAccounts.getIn(['byId', accountId]);
const accountsBasicValidationRule = ({immAccounts, accountId}) => !!immAccounts.getIn(['byId', accountId]); // TODO: Check this validation.
const accountCanHaveChequesOrDebits = (immAccounts, accountId) => {
    const immAccount = extractAccount(immAccounts, accountId);
    return isChequeOrDebitAccount(immAccount.get('newProduct'), immAccount.get('accountType'))
};
const accountUpgradeableToPayroll = (immAccounts, accountId) => {
    const immAccount = extractAccount(immAccounts, accountId);
    return isUpgradeableToPayrollAccount(immAccount.get('newProduct'), immAccount.get('accountType'))
};

const isAccountOtherThanOYSavingAndForeignCurrency = (immAccounts,accountId) => {
    const accountsIndexes = immAccounts.get('byOrder').filter(accountId =>
        // We remove the accounts that are not in euros
        immAccounts.getIn(['byId', accountId, 'balance', 'currency']) === EURO_TEXT
    ).filter(accountId =>
        // We remove the open young saving account
        (immAccounts.getIn(['byId', accountId, 'newProduct']) !== OPENYOUNG_ACCOUNT_TYPE ||
        immAccounts.getIn(['byId', accountId, 'accountType']) !== OPENYOUNG_ACCOUNT_SUBTYPE)
    );
    return accountsIndexes.includes(accountId);
};

const isCurrentAccount = (immAccounts,accountId) => {
    const immAccount = extractAccount(immAccounts, accountId);
    const accountType = immAccount.get('newProduct');
    return accountType === CURRENT_ACCOUNT_TYPE;
};

const isAccountOtherThanBasicPaymentAccount = (immAccounts,accountId) => {
    const immAccount = extractAccount(immAccounts, accountId);
    const accountSubtype = immAccount.get('accountType');
    return accountSubtype !== BASIC_PAYMENT_ACCOUNT_SUBTYPE;
};

const accountChequeIndexValidationRule = {
    redirectURL: ACCOUNTS_REDIRECT_URL,
    validator: ({immAccounts, accountId, chequebookIndex, immAccountsCheques}) => {
        return accountsBasicValidationRule({immAccounts, accountId}) && accountCanHaveChequesOrDebits(immAccounts, accountId) && !!immAccountsCheques.getIn([accountId, 'byOrder', chequebookIndex], false);//TODO: Check this rule
    }
};

const accountUploadDocumentation = (immAccounts, accountId, immAccountAddDocumentation) => {
    const immAccount = extractAccount(immAccounts, accountId);
    return immAccount.getIn(['interveners', 'list']).size === 1 && !!immAccountAddDocumentation && immAccountAddDocumentation.get('canUploadDocumentation');
}

const accountsDefaultValidation = {
    redirectURL: ACCOUNTS_REDIRECT_URL,
    validator: accountsBasicValidationRule
};

const accountValidationRules = {
    ACCOUNTS_MOVEMENTS: accountsDefaultValidation,
    ACCOUNTS_SETTLEMENTS: accountsDefaultValidation,
    ACCOUNTS_SETTLEMENTS_DETAILS: accountsDefaultValidation,//TODO: add validation of settlements.
    ACCOUNTS_DETAILS: accountsDefaultValidation,
    ACCOUNTS_DEBIT_ANNULATION_PAYMENT: accountsDefaultValidation,
    ACCOUNTS_DEBIT_RETURN: accountsDefaultValidation,
    ACCOUNTS_DEBITS: {
        redirectURL: ACCOUNTS_REDIRECT_URL,
        validator: ({immAccounts, accountId}) => accountsBasicValidationRule({immAccounts, accountId}) && accountCanHaveChequesOrDebits(immAccounts, accountId)
    },
    ACCOUNTS_DEBITS_EDIT_VIEW: accountsDefaultValidation,
    ACCOUNTS_CHEQUES: {
        redirectURL: ACCOUNTS_REDIRECT_URL,
        validator: ({immAccounts, accountId}) => accountsBasicValidationRule({immAccounts, accountId}) && accountCanHaveChequesOrDebits(immAccounts, accountId)
    },
    ACCOUNTS_CHEQUEBOOK: accountChequeIndexValidationRule,
    ACCOUNTS_CANCEL_CHEQUEBOOK: accountChequeIndexValidationRule,
    ACCOUNTS_CANCEL_CHEQUE: {
        redirectURL: ACCOUNTS_REDIRECT_URL,
        validator: ({immAccounts, accountId}) => accountsBasicValidationRule({immAccounts, accountId}) && accountCanHaveChequesOrDebits(immAccounts, accountId)
    },
    ACCOUNTS_INTERVENER_REMOVE: accountsDefaultValidation,
    ACCOUNTS_NEW_CHEQUEBOOK: accountsDefaultValidation,
    ACCOUNT_PORTABILITY: {
        validator: ({immAccounts, accountId}) => accountsBasicValidationRule({immAccounts, accountId}) && isCurrentAccount(immAccounts, accountId) && isAccountOtherThanBasicPaymentAccount(immAccounts, accountId)
    },
    ACCOUNT_UPGRADEABLE_TO_PAYROLL: {
        validator: ({immAccounts, accountId}) => accountsBasicValidationRule({immAccounts, accountId}) && accountUpgradeableToPayroll(immAccounts, accountId)
    },
    ACCOUNT_AMAZON_GIFT_CARD: {
        validator: ({immAccounts, accountId}) => accountsBasicValidationRule({immAccounts, accountId}) && isAccountOtherThanOYSavingAndForeignCurrency(immAccounts, accountId)
    },
    ACCOUNT_UPLOAD_DOCUMENTATION: {
        validator: ({immAccounts, immAccountAddDocumentation, accountId}) => accountsBasicValidationRule({immAccounts, accountId}) && isAccountOtherThanBasicPaymentAccount(immAccounts, accountId) && accountUploadDocumentation(immAccounts, accountId, immAccountAddDocumentation)
    }
};

module.exports = {
    accountValidationRules,
    accountConstants
};
